module.exports = __webpack_public_path__ + "img/back-logo.0ce3ca3a.svg";